import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineLaptopIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 14h-1V7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v7H3a1.0002 1.0002 0 0 0-1 1v2a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-2a1.0001 1.0001 0 0 0-1-1ZM6 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7H6V7Zm14 10a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1v-1h16v1Z"/>
  </SvgIcon>
}

export default LineLaptopIcon
